<template>
    <td class="py-1 text-center align-middle">
        <div>
            <fas icon="birthday-cake" style="width: 1.1em"></fas>
            <span class="mx-auto px-1 text-center">{{player.age | int}}</span>
        </div>
        <div v-if="!ageOnly">
            <fas icon="dumbbell" style="width: 1.1em"></fas>
            <span class="mx-auto px-1 text-center">{{player.strength | int}}</span>
        </div>
    </td>
</template>

<script>
    export default {
        props: {
            player: Object,
            ageOnly: {
                type: Boolean,
                default: false
            }
        }
    }
</script>